import {PAYMENT_PROVIDERS_TYPE_TO_SLUG} from '../../../common/constants/payment-providers';

const getPaymentProviders = (payments) =>
  Object.keys(payments)
    .map((provider) => PAYMENT_PROVIDERS_TYPE_TO_SLUG[provider])
    .filter((val) => val);

export default getPaymentProviders;
